import { createSelector } from 'reselect';

import { StateType } from '../../../states';
import { type Selector } from '../../../types/selectors';
import { type UserMissions, type UserMissionState, type UserMissionStatus } from '../types/state/userMissions';

import { getMissionIdFromProps } from './utils';

const emptyObj = {};

export const selectUserMissionsState: Selector<UserMissions> = createSelector(
  (state: StateType) => state.userMissions,
  (userMissions) => userMissions ?? emptyObj,
);

export const selectUserMission: Selector<UserMissionState | undefined> = createSelector(
  [selectUserMissionsState, getMissionIdFromProps],
  (userMissions, missionId) => (missionId ? userMissions[missionId] : undefined),
);

export const selectUserMissionStatus: Selector<UserMissionStatus | undefined> = createSelector(
  [selectUserMission],
  (userMission) => userMission?.status,
);

export const selectUserMissionHasUserRegistered: Selector<boolean> = createSelector(
  [selectUserMission],
  (userMission) => userMission?.hasUserRegistered ?? false,
);
